<div [class.component-main]="!embedded" [class.embedded]="embedded">
    <div class="content-space-between">
        <h1>{{ pageTitle | myLbTranslate }} {{ regionId ? (' - ' + regionName) : '' }}</h1>
    </div>
    <form [formGroup]="regionForm">
        <div *ngIf="step === 1" formGroupName="step1">
            <div class="form-group">
                <label for="name">{{ 'name' | myLbTranslate }}*</label>
                <div class="form-content">
                    <input formControlName="name" id="name" name="name" type="text">
                    <app-validation-messages [control]="regionForm.get('step1.name')"></app-validation-messages>
                    <app-help class="help-button" tag="regions-add-edit-region_name"></app-help>
                </div>
            </div>
        </div>
        <div *ngIf="step === 2" formGroupName="step2">
            <div class="form-group" *ngFor="let control of subnets.controls; index as i">
                <label *ngIf="i === 0" for="name">{{ 'subnet' | myLbTranslate }}*</label>
                <div class="form-content">
                    <input
                        id="subnet{{i}}"
                        [formControl]="getFormControl(control)"
                        name="subnets"
                        type="text"
                        (change)="checkForDuplicateSubnets()">
                    <ng-container
                        *ngIf="pageType === 'addRegion' || pageType === 'editRegion' || pageType === 'addSubnet'">
                        <ng-container *ngIf="i === currentIndex else remove">
                            <img
                                ngSrc="assets/shared/icons/plus.svg"
                                height="20"
                                width="20"
                                [class.disabled]="regionForm.get('step2.subnets.' + i).invalid
                                || !regionForm.get('step2.subnets.' + i).value"
                                (click)="addSubnet(i)"/>
                        </ng-container>
                        <ng-template #remove>
                            <img
                                ngSrc="assets/shared/icons/minus.svg"
                                height="20"
                                width="20"
                                (click)="removeSubnet(i)"/>
                        </ng-template>
                    </ng-container>
                    <app-validation-messages [control]="regionForm.get('step2.subnets.' + i)"></app-validation-messages>
                    <ng-container *ngIf="pageType === 'editSubnet'">
                        <app-help class="help-button" tag="regions-add-edit-region_subnet"></app-help>
                    </ng-container>
                </div>
            </div>
        </div>
    </form>
</div>
<div class="component-footer" [class.embedded]="embedded">
    <button id="add-region-cancel" class="outline" (click)="cancel()">
        {{ 'cancel' | myLbTranslate }}
    </button>
    <button *ngIf="step > 1" id="add-region-back" class="outline" (click)="back()">
        {{ 'back' | myLbTranslate }}
    </button>
    <ng-container *ngIf="step === 2 else next">
        <app-loading-button
            buttonClass="primary"
            buttonText="submit"
            [isDisabled]="regionForm.invalid || regionForm.pristine"
            [callBack]="submitRegion.bind(this)">
        </app-loading-button>
    </ng-container>
    <ng-template #next>
        <button
            id="add-edit-region-next"
            class="primary"
            [disabled]="regionForm.get('step1.name').invalid"
            (click)="nextStep()">
            {{ 'next' | myLbTranslate }}
        </button>
    </ng-template>
</div>
